import { useContext } from 'react';

import { OfferMessageTooltipContext, OfferMessageTooltipProps } from './context';

export const useOfferMessageTooltip = (): OfferMessageTooltipProps => {
  const context = useContext(OfferMessageTooltipContext);
  if (!context) {
    throw new Error('useOfferMessageTooltip must be used within an OfferMessageTooltipProvider');
  }

  return context;
};
